/**
 * @file useIsTablet.ts
 *
 * @fileoverview Help determine if the user is in tablet using matchmedia.
 */

import { useIsScreenSize } from "./useIsScreenSize";

export const useIsTablet = () => useIsScreenSize("tablet", "mobile");
